<div
  class="AmBagsCounter"
  [ngStyle]="{
    border: passenger.isAllowedToRedeem || bagsRedempted ? '3px solid #007bff' : 'none'
  }"
  [ngClass]="{
    'AmBagsCounter--xl': size == 'xl',
    'AmBagsCounter--lg': size == 'lg',
    'AmBagsCounter--md': size == 'md',
    'AmBagsCounter--sm': size == 'sm'
  }"
>
  <div
    class="AmBagsCounter-content"
    [ngClass]="{
      'AmBagsCounter-content--xl': size == 'xl',
      'AmBagsCounter-content--lg': size == 'lg' || size == 'md' || size == 'sm'
    }"
  >
    <div class="AmBagsCounter-header text-center">
      <span
        class="AmBagsCounter-namePax"
        [ngClass]="{
          'fs-35px fw-medium-x lh-44px': size == 'xl',
          'fs-24px fw-medium-x lh-30px': size == 'lg' || size == 'md' || size == 'sm'
        }"
      >
        {{ truncateTextUi(passenger.displayName) | titlecase }}
      </span>
    </div>
    <div class="AmBagsCounter-body">
      <div class="AmBagsCounter-count">
        <button
          class="AmBagsCounter-button"
          [disabled]="totalBags == 0"
          (click)="onMinus()"
          [ngClass]="{
            'AmBagsCounter-button--xl fs-52px': size == 'xl',
            'AmBagsCounter-button--lg fs-40px': size == 'lg' || size == 'md' || size == 'sm',
            'AmBagsCounter-button--disabled': totalBags == 0
          }"
        >
          -
        </button>
        <div
          class="AmBagsCounter-viewTotal"
          [ngClass]="{
            'AmBagsCounter-viewTotal--xl': size == 'xl',
            'AmBagsCounter-viewTotal--lg': size == 'lg' || size == 'md' || size == 'sm'
          }"
        >
          <span
            class="fw-medium-x"
            [ngClass]="{
              'fs-57px lh-89px': size == 'xl',
              'fs-38px lh-60px': size == 'lg' || size == 'md' || size == 'sm'
            }"
          >
            {{ totalBags }}
          </span>
        </div>
        <button
          class="AmBagsCounter-button"
          [disabled]="isNextBagUnavailable || (!blockPlus && totalBags == limitBags)"
          (click)="onPlus()"
          [ngClass]="{
            'AmBagsCounter-button--xl fs-52px': size == 'xl',
            'AmBagsCounter-button--lg fs-40px': size == 'lg' || size == 'md' || size == 'sm',
            'AmBagsCounter-button--disabled':
              isNextBagUnavailable || (!blockPlus && totalBags == limitBags)
          }"
        >
          +
        </button>
      </div>
    </div>
    <div class="AmBagsCounter-status">
      <span
        class="fw-regular text-am-warning"
        [ngClass]="{
          'fs-26px lh-38px': size == 'xl',
          'fs-18px lh-26px': size == 'lg' || size == 'md' || size == 'sm'
        }"
        *ngIf="isNextBagUnavailable && !showCopyBagsIncluded && !bagsToPayPax"
      >
        {{ 'bagsSelection.bag-status.unavailable' | translate }}
      </span>
      <span
        class="fw-regular"
        [ngClass]="{
          'fs-26px lh-38px': size == 'xl',
          'fs-18px lh-26px': size == 'lg' || size == 'md' || size == 'sm'
        }"
        *ngIf="showCopyBagsIncluded"
      >
        {{ 'bagsSelection.bag-status.include' | translate }}
      </span>
      <span
        class="fw-regular"
        [ngClass]="{
          'fs-26px lh-38px': size == 'xl',
          'fs-18px lh-26px': size == 'lg' || size == 'md' || size == 'sm'
        }"
        *ngIf="bagsRedempted && !showCopyBagsIncluded && !bagsToPayPax"
      >
        {{ 'redeemBag.redeemed' | translate }}
      </span>
      <span class="d-flex gap-2 align-items-center" *ngIf="bagsToPayPax">
        <span
          [ngClass]="{
            'fs-26px lh-38px fw-regular': size == 'xl',
            'fs-18px lh-26px fw-regular': size == 'lg' || size == 'md' || size == 'sm'
          }"
        >
          {{ 'bagsCounter.total' | translate }}
        </span>
        <span
          class="text-am-white"
          [ngClass]="{
            'fs-35px lh-44px fw-medium-x': size == 'xl',
            'fs-24px lh-30px fw-medium-x': size == 'lg' || size == 'md' || size == 'sm'
          }"
        >
          <b>{{ totalCostBagsPax | amCurrency }}</b>
        </span>
        <span
          class="text-am-white"
          [ngClass]="{
            'fs-24px lh-35px fw-regular': size == 'xl',
            'fs-16px lh-24px fw-regular': size == 'lg' || size == 'md' || size == 'sm'
          }"
        >
          {{ currencyCode }}
        </span>
      </span>
    </div>
  </div>
  <div
    class="AmBagsCounter-footer"
    [ngClass]="{
      'AmBagsCounter-footer--xl': size == 'xl',
      'AmBagsCounter-footer--lg': size == 'lg' || size == 'md' || size == 'sm'
    }"
    *ngIf="passenger.isAllowedToRedeem || bagsRedempted"
  >
    <a
      class="AmBagsCounter-linkModal fw-regular"
      [ngClass]="{
        'AmBagsCounter-linkModal--xl fs-24px lh-34px': size == 'xl',
        'AmBagsCounter-linkModal--lg fs-16px lh-24px': size == 'lg' || size == 'md' || size == 'sm'
      }"
      (click)="handleModalRedeem()"
    >
      <span *ngIf="passenger.isAllowedToRedeem">{{ 'redeemBag.useBenefit' | translate }}</span>
      <span *ngIf="!passenger.isAllowedToRedeem && bagsRedempted">{{
        'redeemBag.activatedBenefit' | translate
      }}</span>
      <img
        alt="symbol"
        class="AmBagsCounter-icon"
        src="../../../../assets/images/questCircle.svg"
      />
    </a>
    <am-input-switch
      [isAllowedToRedeem]="passenger.isAllowedToRedeem"
      [className]="'AmBagsCounter-switch--' + size"
      size="sm"
      (change)="activeBenefit($event)"
      *ngIf="passenger.isAllowedToRedeem"
      [(ngModel)]="passenger.switchRedeem"
    ></am-input-switch>
  </div>
</div>
